jQuery(function ($) {

  function store_message(message) {
    $( '#occ_gift_message_apply' ).append(' <span class="loading"></span>').prop('disabled', true);
    $( '#occ_gift_response' ).hide();
    $.ajax( {
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data: 'action=update_cart&occ_gift_message=' + message,
        success:  function( response ) {
            $( '#occ_gift_response' ).html('Gift message updated!').show();
            $( '#occ_gift_message_apply' ).find('.loading').remove();
            $( '#occ_gift_message_apply' ).prop("disabled", false);
        }
    } );
    return false;
  }

  $( 'div.cart-collaterals' ).on( 'click', '#occ_gift_message_apply', function( e ) {
    var message = $( '#occ_gift_message' ).val();
    store_message(message);
  } );

  function delay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  $('#occ_gift_message').keyup(delay(function (e) {
    //console.log('Time elapsed!', this.value);

    var message = jQuery(this).val();
    store_message(message);

  }, 500));
});
